import React from 'react';
import {InertiaLink, useForm, usePage} from "@inertiajs/inertia-react";
import LoadingButton from "@/Shared/LoadingButton";
import MerchantForm from "@/Pages/Merchants/Assets/MerchantForm";
import Layout from "@/Shared/Layout";

const Create = () => {
  const {categories} = usePage().props;
  const {data, setData, errors, post, processing} = useForm({
    merchant_name: "",
    short_description: "",
    description: "",
    homepage_url: "",
    merchant_link_url: "",
    def_image_logo: "",
    relative_uri: "",
    keywords: "",
    merchant_sort_name: "",
    merchant_text_linkname: "",
    category_id: [],
    showonline: false,
    txtCouponName: "",
    txtCouponPlace: "",
    internal_notes: "",
    intNetworkID: 0,
    intAdvertiserID: 0,
  });

  function handleSubmit(e) {
    e.preventDefault();
    post(route('added.merchants.store').url());
  }



  return (
    <div>
      <h1 className="mb-8 text-3xl font-bold">
        <InertiaLink
          href={route('added.merchants')}
          className="text-indigo-600 hover:text-indigo-700"
        >
          Added Merchants
        </InertiaLink>
        <span className="font-medium text-indigo-600"> /</span> Create
      </h1>
      <div className="max-w-3xl overflow-hidden bg-white rounded shadow">
        <form onSubmit={handleSubmit}>
          <MerchantForm categories={categories} errors={errors} data={data} setData={setData}/>
          <div className="flex items-center justify-end px-8 py-4 bg-gray-100 border-t border-gray-200">
            <LoadingButton
              loading={processing}
              type="submit"
              className="btn-default"
            >
              Create Merchant
            </LoadingButton>
          </div>
        </form>
      </div>
    </div>
  );
};

Create.layout = page => <Layout title="Create merchant" children={page}/>;
export default Create;
